import { render, staticRenderFns } from "./referee_operate.vue?vue&type=template&id=2830be3e&scoped=true"
import script from "./referee_operate.vue?vue&type=script&lang=js"
export * from "./referee_operate.vue?vue&type=script&lang=js"
import style0 from "./referee_operate.vue?vue&type=style&index=0&id=2830be3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830be3e",
  null
  
)

export default component.exports